<template>
    <input-select
        :label="label"
        :name="name"
        :no_selection="no_selection"
        :options="states"
        :value="value"
        :read_only="read_only"
    />
</template>

<script>
import us_states from '../components/us-states.js';
import ng_states from '../components/ng-states.js';
import InputSelect from './input-select.vue';

export default {
    components: {
        InputSelect,
    },

    props: {
        label: {},
        name: {},
        no_selection: { default: 'Select '},
        value: {},
        read_only: { default: false },
    },

    data() {
        return {
            states: store?.state?.tenant === 'ng' ? ng_states : us_states,
        }
    },
}
</script>
